import axios from 'axios'
let confirmOrderParams = { payStatus: 1, orderStatus: 2, pageId: 1, pageSize: 10 };
const baseServiceUrl = '/trip-package-auditapi/api/biz/';

export const getConfirmOrders = function(params) {
    return axios.get(`${baseServiceUrl}order/list`, {
        params: Object.assign(confirmOrderParams, params || {})
    }).then(response => {
        return response.data;
    });
};


// WEBPACK FOOTER //
// ./src/api/packageproduct.js